"use strict";

// todo разделить на два компонента - менеджер табов и интерфейса в целом и редактор темы
Fotobook.themeRoller = {
    selector: '#fotobook-themeroller',
    cookieName: "tr-settings",

    init: function(){
        const $themeroller = $(Fotobook.themeRoller.selector);
        if (!$themeroller.length){
            return;
        }
        Fotobook.themeRoller.initTabs();
        Fotobook.themeRoller.initAccordions();
        Fotobook.themeRoller.initImagesPreview();

        // Init panel state settings
        let settings = Fotobook.$cookies.get(Fotobook.themeRoller.cookieName);
        if (settings && settings.constructor === Object) {
            if (settings.trShow){
                $themeroller.addClass("show");
            }
            $.each(settings.headers,function(i, v){
                $themeroller.find('.header[data-tr-header='+v+']').addClass('active');
            });
            $themeroller.find('.tab-header[data-content-id='+settings.activeTab+']').click();
        }

        /**
         * События на изменение текста кастомного стиля
         */
        $('#custom-css-text').on('change', function(event){
            Fotobook.themeRoller.saveCustomStyle();
        }).on("keydown", function(event){
            if (event.ctrlKey && event.keyCode == 13) {
                Fotobook.themeRoller.saveCustomStyle();
            }
        });

        //обновление темы после изменения параметров размера шрифта
        $(".font-settings-pick").on("change", function(){
            var $this = $(this),
                attr = $this.attr("data-var"),
                val = $this.val(),
                params = {};

            if ($this.hasClass("font-size-pick")){
                val = parseInt(val, 10) + "px";
            }
            $this.val(val);
            params[attr] = val;
            Fotobook.themeRoller.changeThemeParams(params);
        })
            // по ховеру подсвечиваем элементы, которые используют данную переменную
            .hover(
                function () {
                    Fotobook.themeRollerHighlighter.hoverOn($(this));
                },
                function () {
                    Fotobook.themeRollerHighlighter.hoverOff($(this));
                }
            );

        $(".sprite-upload").on("change", function(){
            var formData = new FormData();

            formData.append("Filedata", $(this).prop("files")[0]);
            formData.append("fileParam", $(this).attr("data-image"));
            Fotobook.ajax.postJSON("/themeroller/theme/upload-file", {
                "data" : formData,
            });
        });

        Fotobook.themeRoller.initColorPickers();
        Fotobook.ajax.getJSON('/themeroller/theme/get-custom-params');
    },

// -----------------------------------------------------------------------------------------------------
// колорпикеры

    paramsChangeTimeout: null,
    enqueueParamsChange: function(params, timeout){
        var self = this;
        if (this.paramsChangeTimeout){
            clearTimeout(this.paramsChangeTimeout);
        }
        this.paramsChangeTimeout = setTimeout(function(){
            this.paramsChangeTimeout = null;
            Fotobook.themeRoller.changeThemeParams(params);
        }, timeout);
    },
    colorpickerCommonHandler: function(event, data, input, ok){
        var $input = $(input),
            params = {},
            attr = $input.attr("data-var");
        this.updateColorInput($input, data.formatted);
        params[attr] = $input.val();
        this.enqueueParamsChange(params, ok ? 0 : 1000);
    },
    initOneColorPicker: function(input){
        var self = this,
            $input = $(input),
            alpha = $input.attr("data-support-rgba") === "true";

        // по ховеру подсвечиваем элементы, которые используют данную переменную
        $input.hover(
            function () {
                Fotobook.themeRollerHighlighter.hoverOn($(this));
            },
            function () {
                Fotobook.themeRollerHighlighter.hoverOff($(this));
            }
        );

        $input.colorpicker({
            "alpha": alpha,
            "stop": function(event, data){
                // отправляем с задержкой в секунду, чтобы можно было редактировать поля с клавиатуры
                self.colorpickerCommonHandler(event, data, this, false);
            },
            "ok": function(event, data){
                // отправляем сразу
                self.colorpickerCommonHandler(event, data, this, true);
            },
            "select" : function(event, data){
                self.updateColorInput($(this), data.formatted);
            },
        });
    },

    initColorPickers: function(){
        var self = this;
        $(Fotobook.themeRoller.selector).find(".color-pick").attr("readonly", "readonly").each(function(){
            return self.initOneColorPicker(this);
        });

        $(".picker-icon").off("click").on("click", function () {
            var $input = $(this).siblings(".color-pick");
            setTimeout(function(){
                $input.colorpicker("open");
            }, 0);
        });
    },

    updateColorInput: function($element, color){
        var webColor = new WebColor(color);

        color = webColor.get_smart();
        $element.val(color).css({
            "background-color" : color,
            "color" : webColor.selectContrastColor(),
        });
    },


    updateThemeCustomStyles: function(response){
        if (!response || !response.custom_styles){
            return;
        }
        $("#custom-css-text").val(response.custom_styles);
    },

    updateThemeCssLink: function(response){
        if (!response || response.link === undefined){
            return;
        }
        if (response.link === false){
            $(".theme-css").remove();
            return;
        }

        var $link = $("<link>", {
                "rel" : "stylesheet",
            }).appendTo("head");

        // Для того, чтобы не было моргания дефолтных стилей, загружаем новый файл со стилями,
        // после чего удаляем элемент со старыми стилями
        $link.on("load", function(event){
            $(".theme-css").remove();
            $link.addClass("theme-css");
        }).attr("href", response.link);
    },

    /**
     * Обрабатывает данные в аякс-ответах
     */
    updateParams: function(response){
        this.updateThemeParams(response);
        this.updateThemeCustomStyles(response);
        this.updateThemeCssLink(response);
    },

    changeThemeParams: function(params){
        return Fotobook.ajax.postJSON("/themeroller/theme/change-params", {
            "data" : {
                "params" : params,
            },
            "longQueryTimeout": 2000,
        });
    },

    downloadTheme: function(){
        $(".download-css-theme-iframe").attr("src", "/themeroller/export/download?v=" + Date.now());
    },

    /**
     * Загрузить тему
     * @param file
     */
    uploadTheme(e) {
        const file = e.target.files[0];

        if (!/\.zip$/.test(file.name)) {
            return Promise.reject(t('photobook-js-themeroller-wrongFile'));
        }

        const formData = new FormData();
        formData.append('theme', file, file.name);
        return Fotobook.ajax.postJSON('/themeroller/import/upload', {
            data: formData,
        });
    },

    applyCurrentTheme: function(event){
        Fotobook.ajax.postJSON("/themeroller/theme/apply-current").then((response) => {
            if (response.data.success){
                Fotobook.notification.showSuccess(t("photobook-js-themeroller-themeSaved"));
            }
        }).catch(() => {});
    },

    /**
     * Сбросить текущие изменения
     * @param event
     */
    resetCurrentTheme: function(event){
        Fotobook.ajax.postJSON("/themeroller/theme/reset-current");
    },
    /**
     * Восстановить оригинальную тему
     * @param event
     */
    restoreOriginalTheme: function(event){
        Fotobook.ajax.postJSON("/themeroller/theme/restore-original");
    },

    /**
     * Обновить кастомный стиль темы и получить URL на файл стиля
     * @returns {boolean}
     */
    saveCustomStyle: function(){
        Fotobook.ajax.postJSON("/themeroller/theme/change-custom-style", {
            "data" : {
                "custom_styles" : $("#custom-css-text").val(),
            },
        });
    },

// -----------------------------------------------------------------------------------------------------

    initTabs: function(){
        var $tabs  = $("#themeroller-tabs");

        $tabs.find('.tab-header').off('click').on('click', function(){
            var contentID = $(this).attr('data-content-id');
            $('.tab-header').removeClass('active');
            $('.tab-content').removeClass('visible');
            $(this).addClass('active');
            $('#'+contentID).addClass('visible');
            $('#roller-content').addClass('css-tab-active');
            Fotobook.themeRoller.checkJSP();
            Fotobook.themeRoller.setCookie();
        });
    },

    initAccordions: function(){
        $('#themeroller-tabs').find('.header').off('click').on('click',function(){
            var accordion = $('.tab-content.visible').find('.themeroller-accordion');
            $(this).toggleClass('active');
            Fotobook.themeRoller.checkJSP();
            Fotobook.themeRoller.setCookie();
            if(accordion.find('.jspPane').length && (accordion.find('.jspPane').height() < parseInt(accordion.css('max-height'), 10))){
                const jsp = accordion.data("jsp");
                if (jsp) {
                    jsp.destroy();
                }
            }
        });
    },

    checkJSP: function(){
        var activeTab = $('#themeroller-tabs').find('.tab-header.active'),
            headerHeight = $("#show-hide").height(),
            buttonsPanelHeight = $(".tr-general-buttons").height(),
            maxHeight = $(window).height() - headerHeight - buttonsPanelHeight - 105,
            accordion = $('#'+activeTab.data('contentId')).find('.themeroller-accordion');

        if (accordion.length){
            accordion.css({
                'max-height': maxHeight,
                'height': maxHeight,
            });
            if (accordion.data('jsp')){
                accordion.data('jsp').reinitialise();
            } else {
                setTimeout(() => accordion.initJsp(), 0);
            }
        }
    },

    initImagesPreview: function(){
        $('#themeroller-tabs').find('.image-preview').off('click').on('click', function(){
            var bg = $(this).css('background-image'),
                dialog = $('.tr-full-preview-dialog');
            bg = bg.replace('url(','').replace(')','');
            if(dialog.length){
                dialog.dialog('close');
            }
            $('<img class="tr-full-preview-dialog" src='+bg+' alt="">').dialog({
                title: t('photobook-js-tr-full-preview-title'),
                width: 'auto',
                height: 'auto',
                resizable: false,
                dialogClass: 'fotobook-dialog editor upper-dialog image-full-preview',
                close: function(){
                    $(this).remove();
                }
            });

        });
    },

    setCookie: function(){
        var settings = {
                trShow: false,
                activeTab: 'css-tab',
                headers: []
            },
            themeroller = $(Fotobook.themeRoller.selector);
        if(themeroller.hasClass('show')){
            settings.trShow = true;
        }
        settings.activeTab = themeroller.find('.tab-header.active').data('content-id');
        themeroller.find('.header.active').each(function(){
            settings.headers.push($(this).data('tr-header'));
        });
        Fotobook.$cookies.set(Fotobook.themeRoller.cookieName, settings);
    },

    updateThemeParams: function(response){
        var params,
            self = this;
        if (!response || !response.params){
            return;
        }

        $.each(response.params, function(name, value){
            var $inputField = $(".themeroller-accordion").find('[data-var="' + name + '"]');

            if ($inputField.hasClass("color-pick")){
                self.updateColorInput($inputField, value);
            } else {
                $inputField.val(value);
            }
        });
    },
};

$(Fotobook.themeRoller.init);


$(document)
.on(Fotobook.events.AJAX_DONE, function(event, result, response){
    if (response && response.data && response.data.themeroller) {
        Fotobook.themeRoller.updateParams(response.data.themeroller);
    }
})
.on("click", ".upload-theme-input", function(event){
    $(this).find("input").val(""); // Chrome same file upload fix
})
.on("change", ".upload-theme-input", function(event){
    Fotobook.themeRoller.uploadTheme(event).catch((message) => {
        Fotobook.notification.showError(message);
    });
})
.on("click", "#show-hide", function(event){
    $(Fotobook.themeRoller.selector).toggleClass("show");
    Fotobook.themeRoller.checkJSP();
    Fotobook.themeRoller.setCookie();
})
.on("click", ".reset-current-css-theme", Fotobook.themeRoller.resetCurrentTheme)
.on("click", ".restore-original-css-theme", Fotobook.themeRoller.restoreOriginalTheme)
.on("click", ".apply-current-css-theme", Fotobook.themeRoller.applyCurrentTheme)
.on("click", ".download-css-theme", Fotobook.themeRoller.downloadTheme)
;

$(window)
.on("resize", function(event){
    Fotobook.themeRoller.checkJSP();
});

